import { Component, Output, EventEmitter, Input } from "@angular/core";
import { CoreService } from "src/app/data/datasource/local/core.service";
import { MatDialog } from "@angular/material/dialog";
import { navItems } from "../../vertical/sidebar/sidebar-data";
import { TranslateService } from "@ngx-translate/core";
import { Router, RouterModule } from "@angular/router";
import { TablerIconsModule } from "angular-tabler-icons";
import { MaterialModule } from "src/app/material.module";
import { BrandingComponent } from "../../vertical/sidebar/branding.component";
import { AppSettings } from "src/app/config";
import { FormsModule } from "@angular/forms";
import { AuthService } from "src/app/core/auth/services/auth.service";

interface notifications {
  id: number;
  icon: string;
  color: string;
  title: string;
  time: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  title: string;
  link: string;
  new?: boolean;
}

interface apps {
  id: number;
  icon: string;
  color: string;
  title: string;
  subtitle: string;
  link: string;
}

@Component({
  selector: "app-horizontal-header",
  imports: [RouterModule, TablerIconsModule, MaterialModule, BrandingComponent],
  templateUrl: "./header.component.html",
})
export class AppHorizontalHeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  @Output() optionsChange = new EventEmitter<AppSettings>();

  public selectedLanguage: any = {
    language: "Español (México)",
    code: "es",
    type: "MX",
    icon: "/assets/images/flag/icon-flag-es.svg",
  };

  public languages: any[] = [
    {
      language: "English",
      code: "en",
      type: "US",
      icon: "/assets/images/flag/icon-flag-en.svg",
    },
    {
      language: "Español",
      code: "es",
      type: "MX",
      icon: "/assets/images/flag/icon-flag-es.svg",
    },
  ];
  /*
  {
    language: "Français",
    code: "fr",
    icon: "/assets/images/flag/icon-flag-fr.svg",
  },
  {
    language: "German",
    code: "de",
    icon: "/assets/images/flag/icon-flag-de.svg",
  },
  */

  constructor(
    private settings: CoreService,
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
  ) {
    translate.setDefaultLang("es");
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppHorizontalSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  options = this.settings.getOptions();

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }

  setlightDark(theme: string) {
    this.options.theme = theme;
    this.emitOptions();
  }

  notifications: notifications[] = [
    {
      id: 1,
      icon: "a-b-2",
      color: "primary",
      time: "8:30 AM",
      title: "Launch Admin",
      subtitle: "Just see the my new admin!",
    },
    {
      id: 2,
      icon: "calendar",
      color: "secondary",
      time: "8:21 AM",
      title: "Event today",
      subtitle: "Just a reminder that you have event",
    },
    {
      id: 3,
      icon: "settings",
      color: "warning",
      time: "8:05 AM",
      title: "Settings",
      subtitle: "You can customize this template",
    },
    {
      id: 4,
      icon: "a-b-2",
      color: "success",
      time: "7:30 AM",
      title: "Launch Templates",
      subtitle: "Just see the my new admin!",
    },
    {
      id: 5,
      icon: "exclamation-circle",
      color: "error",
      time: "7:03 AM",
      title: "Event tomorrow",
      subtitle: "Just a reminder that you have event",
    },
  ];

  profiledd: profiledd[] = [
    {
      id: 1,
      title: "My Profile",
      link: "/",
    },
    {
      id: 2,
      title: "My Subscription",
      link: "/",
    },
    {
      id: 3,
      title: "My Invoice",
      new: true,
      link: "/",
    },
    {
      id: 4,
      title: " Account Settings",
      link: "/",
    },
  ];

  signOut(): void {
    this.authService.signOut().subscribe(() => {
      this.router.navigate(['/session/login']);
    });
  }

  apps: apps[] = [
    {
      id: 1,
      icon: "solar:chat-line-line-duotone",
      color: "primary",
      title: "Chat Application",
      subtitle: "Messages & Emails",
      link: "/",
    },
    {
      id: 2,
      icon: "solar:checklist-minimalistic-line-duotone",
      color: "secondary",
      title: "Todo App",
      subtitle: "Completed task",
      link: "/",
    },
    {
      id: 3,
      icon: "solar:bill-list-line-duotone",
      color: "success",
      title: "Invoice App",
      subtitle: "Get latest invoice",
      link: "/",
    },
    {
      id: 4,
      icon: "solar:calendar-line-duotone",
      color: "error",
      title: "Calendar App",
      subtitle: "Get Dates",
      link: "/",
    },
    {
      id: 5,
      icon: "solar:smartphone-2-line-duotone",
      color: "warning",
      title: "Contact Application",
      subtitle: "2 Unsaved Contacts",
      link: "/",
    },
    {
      id: 6,
      icon: "solar:ticket-line-duotone",
      color: "primary",
      title: "Tickets App",
      subtitle: "Create new ticket",
      link: "/",
    },
    {
      id: 7,
      icon: "solar:letter-line-duotone",
      color: "secondary",
      title: "Email App",
      subtitle: "Get new emails",
      link: "/",
    },
    {
      id: 8,
      icon: "solar:book-2-line-duotone",
      color: "warning",
      title: "Contact List",
      subtitle: "Create new contact",
      link: "/",
    },
  ];
}

@Component({
  selector: "app-search-dialog",
  imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule],
  templateUrl: "search-dialog.component.html",
})
export class AppHorizontalSearchDialogComponent {
  searchText: string = "";
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
}
